<div class="platform-select">
  <div>
    <div class="social-icon {{activeChannelName}}-icon"></div>
    <div class="social-title">{{channelContent}}</div>
  </div>
  <achoo-filter-box
    name="selectedPlatform"
    [options]="platformsOption"
    [searchable]="false"
    [(model)]="activeChannelId"
    (selectEvent)="onChangePlatform($event)"
    placement="bottom">
  </achoo-filter-box>
</div>



// WEBPACK FOOTER //
// ./src/app/influencer-platform/influencer-details/influencer-overview-tab/platform-select/platform-select.component.html